// extracted by mini-css-extract-plugin
module.exports = {"StudiesProgrammeForm":"style_StudiesProgrammeForm__3LeY0","wrapper":"style_wrapper__26isN","column":"style_column__3ZBIh","wrapperColumn":"style_wrapperColumn__jjXnf"};